import { Accents } from '../../../colors/accents/converters/index.js';
import '../../../colors/accents/accents/index.js';
import '../../../colors/backgrounds/backgrounds/index.js';
import '../../../colors/texts/texts/index.js';
import { Controls } from '../../../colors/controls/converters/index.js';

const ScrollbarSkinValues = {
    accent: {
        trackBackgroundColor: 'transparent',
        thumbBackgroundColor: Accents.primary.base.default,
    },
    control: {
        trackBackgroundColor: 'transparent',
        thumbBackgroundColor: Controls.border.default,
    },
};

export { ScrollbarSkinValues };
